import moment from "moment";

export function getWalletMetrics(summary) {
  const data = summary?.data ?? summary ?? {};
  const available = Number(data.freeBalance ?? 0);
  const frozen = Number(data.frozenBalance ?? 0);
  const withdrawn = Number(data.withdrawalAmount ?? 0);
  const total = Number(available + frozen);

  return {
    available,
    frozen,
    withdrawn,
    total,
    locked: Boolean(data.locked),
    lastUpdated: data.updated_at ?? null,
  };
}

export function formatWalletUpdatedAgo(lastUpdated) {
  if (!lastUpdated) return null;
  const m = moment(lastUpdated);
  if (!m.isValid()) return null;
  return `Updated ${m.fromNow()}`;
}

export function getWalletPercent(value, total) {
  if (!total || total <= 0) return 0;
  return Number(((value / total) * 100).toFixed(2));
}
